export const ITEMS_PER_DESKTOP_SCREEN = 4;
